import type { SVGProps } from "react";
import * as React from "react";

const SvgIconHubspot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 76 75"
    {...props}
  >
    <path
      fill="#FF7A59"
      d="M54.62 26.202v-7.874a6.07 6.07 0 0 0 3.496-5.465v-.18a6.063 6.063 0 0 0-6.064-6.064h-.18a6.063 6.063 0 0 0-6.064 6.063v.181a6.06 6.06 0 0 0 3.496 5.465v7.874a17.17 17.17 0 0 0-8.164 3.595l-21.594-16.82a6.8 6.8 0 0 0 .243-1.702 6.83 6.83 0 1 0-6.84 6.819 6.76 6.76 0 0 0 3.364-.916l21.264 16.547a17.22 17.22 0 0 0 .264 19.4l-6.468 6.47a5.6 5.6 0 0 0-1.616-.264 5.61 5.61 0 1 0 5.615 5.615 5.5 5.5 0 0 0-.264-1.616l6.398-6.4A17.253 17.253 0 1 0 54.62 26.201m-2.652 25.896a8.853 8.853 0 1 1 0-17.696 8.852 8.852 0 0 1 .008 17.692"
    />
  </svg>
);
export default SvgIconHubspot;
